import { buildManagePageQueryString } from "./helpers/buildManagePageQueryString";
import { jumboMediaAPI } from "./service";

export const supportMessagesAPI = jumboMediaAPI.injectEndpoints({
    endpoints: (build) => ({
        getSupportMessages: build.query({
            query: (body) => `/api/SupportMessages/DataTablesSource${buildManagePageQueryString(body.columns, body.page, body.searchTerm, (body.page - 1) * body.limit, body.limit, body.orderColumnIndex, body.isDescSortDir)}`
        }),
        sentMessage: build.mutation({
            query: (body) => ({
                url: '/api/SupportMessages/UserPost',
                method: 'POST',
                body
            }),
        }),
        createSupportMessage: build.mutation({
            query: (body) => ({
                url: '/api/SupportMessages/AdminPost',
                method: 'POST',
                body,
            }),
        }),
        updateSupportMessage: build.mutation({
            query: (body) => {
                return {
                    url: `/api/SupportMessages/AdminPut/${body.Id}`,
                    method: 'PUT',
                    body,
                }
            }
        }),
        deleteSupportMessage: build.mutation({
            query: (body) => ({
                url: `/api/SupportMessages/AdminDelete/${body.id}`,
                method: 'DELETE',
            }),
        }),
        getNumberOfUnprocessedMessages: build.query({
            query: () => `/api/SupportMessages/AdminGetNumberOfUnprocessedMessages`,
        }),
    }),
})

export const {
    useGetSupportMessagesQuery,
    useCreateSupportMessageMutation,
    useUpdateSupportMessageMutation,
    useDeleteSupportMessageMutation,
    useSentMessageMutation,
    useGetNumberOfUnprocessedMessagesQuery,
    useLazyGetNumberOfUnprocessedMessagesQuery,
} = supportMessagesAPI;